import { fetcher } from '@/plugins/request';
const OUT_BASE_URL = window.location.origin;

// 获取基础信息
export function getBaseInfo(params) {
  return fetcher({
    url: `${OUT_BASE_URL}/service/score/options`,
    method: 'post',
    data: params,
  });
}

// 需删除
export function getMockData(params) {
  return fetcher({
    url: `${OUT_BASE_URL}/shop_manage/goods/list`,
    method: 'post',
    data: params,
  });
}

// 获取收货信息列表
export function getContactList(params) {
  return fetcher({
    url: '/contact/list',
    method: 'post',
    data: params,
  });
}

// 新增收货地址
export function getContactAdd(params) {
  return fetcher({
    url: '/contact/add',
    method: 'post',
    data: params,
  });
}

// 更新收货地址
export function getContactEdit(params) {
  return fetcher({
    url: '/contact/edit',
    method: 'post',
    data: params,
  });
}

// 删除收货地址
export function getContactDel(params) {
  return fetcher({
    url: '/contact/del',
    method: 'post',
    data: params,
  });
}
